const TABS_LABELS = {
  PLANS: 'PLANS',
  USAGE: 'USAGE',
  LICENCES: 'LICENCES',
  DEVICES: 'DEVICES',
  ADDONS: 'ADDONS',
  BUDGET: 'BUDGET',
  SETTINGS: 'SETTINGS',
};

const TABS = [
  {
    key: TABS_LABELS.PLANS,
    tab_key: 'soho_business_overview_plan_tab_title',
  },
  {
    key: TABS_LABELS.USAGE,
    tab_key: 'soho_business_overview_usage_tab_title',
  },
  {
    key: TABS_LABELS.LICENCES,
    tab_key: 'soho_business_overview_licences_tab_title',
  },
  {
    key: TABS_LABELS.DEVICES,
    tab_key: 'soho_business_overview_devices_tab_title',
  },
  {
    key: TABS_LABELS.ADDONS,
    tab_key: 'soho_business_overview_addons_tab_title',
  },
  {
    key: TABS_LABELS.BUDGET,
    tab_key: 'soho_business_overview_budget_tab_title',
  },
  {
    key: TABS_LABELS.SETTINGS,
    tab_key: 'soho_business_overview_settings_tab_title',
  },
];

const PLAN_TYPES = {
  REGULAR: 'Regular',
  UNLIMITED: 'Unlimited',
  GROUP: 'Group',
  BROADBAND: 'broadband',
};

const PLAN_SERVICE_TYPES = {
  MOBILE: 'Mobile',
  BROADBAND: 'broadband',
};

const USAGE_TYPES = {
  DATA: 'Data',
  CALLS: 'Calls',
  SMS: 'SMS',
};

const USAGE_CATEGORIES_TYPES = Object.freeze({
  ...USAGE_TYPES,
  SEE_ALL: 'See-All',
});

const USAGE_DISPLAY_TYPES = Object.freeze({
  CATEGORIES: 'categories',
  USERS: 'users',
});

const CONTRACT_DATA_TYPES = {
  RENEWAL: 'renewal-date',
  CONTRACT_END: 'contract-ends',
  MINIMUM_TERM_END: 'minimum-term-ends',
  ELIGIBLE_UPGRADE_FROM: 'eligible-upgrade-from',
};

const USAGE_DURATION_TYPES = {
  DAY: 'Day',
  WEEK: 'Week',
  MONTH: 'Month',
};

const USAGE_INTERVAL_TYPES = {
  HOUR: 'Hour',
  DAY: 'Day',
  WEEK: 'Week',
};

const ADDONS_MY_PROFILE_DISPLAY_TYPES = Object.freeze({
  MY_ADDONS: 'my addons',
  REQUESTS: 'requests',
});

const USAGE_CATEGORIES_IS_LOADING = {
  [USAGE_CATEGORIES_TYPES.SEE_ALL]: 'unfiltered',
  [USAGE_CATEGORIES_TYPES.DATA]: 'data',
  [USAGE_CATEGORIES_TYPES.SMS]: 'sms',
  [USAGE_CATEGORIES_TYPES.CALLS]: 'calls',
};
export {
  TABS_LABELS,
  TABS,
  PLAN_TYPES,
  PLAN_SERVICE_TYPES,
  USAGE_TYPES,
  USAGE_CATEGORIES_TYPES,
  USAGE_CATEGORIES_IS_LOADING,
  USAGE_DISPLAY_TYPES,
  CONTRACT_DATA_TYPES,
  USAGE_DURATION_TYPES,
  USAGE_INTERVAL_TYPES,
  ADDONS_MY_PROFILE_DISPLAY_TYPES,
};
